<template>
    <DsInlineAlert
        type="critical" 
        leading-icon 
        class="error-banner"
    >
        <span>
            {{ $t('funnel.campaign.communications.textmsg.unverified.kmn.alert') }}
            <DsLink
                :href="$options.THRYV_SUPPORT_URL"
                external
                data-qa="unverified-kmn-alert-link"
            >
                {{ $t('funnel.campaign.communications.textmsg.unverified.kmn.alert.link') }}
            </DsLink>
        </span>
    </DsInlineAlert>
</template>

<script>
import { THRYV_SUPPORT_URL } from '@/components/broadcast/constants/smsBroadcast.constants';

export default {
  THRYV_SUPPORT_URL,
};
</script>

<style lang="scss" scoped>
  .error-banner {
      margin-bottom: $spacing-400;
  }
</style>